<!-- 其他人的开发者主页 -->
<template>
    <div id="PersonIndexBox">
      <div class="PersonContentWrap">
          <div @click="ClosePersonBox" class="Close"><img src="../assets/pclose.png"></div>
          <div class="PersonHead flexa">
              <img v-if="PersonData.头像" :src="PersonData.头像">
              <img v-else src="../assets/defaulthead.png">
              <div class="Name"><p>HELLO! I’m</p><p>{{ PersonData.名称 }}</p></div>
          </div>
          <div class="Info">
     <!--         <div class="flexa"><img src="../assets/p_1icon.png"><p>联系地址</p></div>-->
              <div class="flexa Infoitem" v-if="PersonData.电话"><img src="../assets/p_2icon.png"><p>{{ PersonData.电话 }}</p></div>
              <div class="flexa Infoitem" v-if="PersonData.邮箱"><img src="../assets/p_3icon.png"><p>{{ PersonData.邮箱 }}</p></div>
              <div class="Itemcard clearfix" v-if="PersonData.标签">
                  <div class="flex" v-for="(item,index) in PersonData.标签.split(',')" :key="index">{{ item }}</div>
              </div>
          </div>
          <div class="LineCut flexbetween">
              <div class="NewsTitle flexa"><p>开发者 <span>简介</span></p></div>
          </div>
          <div class="Translate">
              <p v-if="PersonData.简介">{{ PersonData.简介 }}</p>
              <p v-else>暂无简介</p>
          </div>
      </div>
    </div>
</template>
<script>
  export default {
    name: 'personindexbox',
    components: {},
    props: {
      PersonData: Object
    },
    created() {
      console.log(this.PersonData);
    },
    data() {
      return {};
    },
    methods: {
      ClosePersonBox() {
        this.$emit('OpenPersonBox');
      }
    }
  };
</script>
<style scoped lang="scss">
    @import '../../public/Value';
    #PersonIndexBox{
        .Close{
            width: 0.12rem;
            height: 0.12rem;
            position: absolute;
            right: 0.06rem;
            top: 0.06rem;
            cursor: pointer;
            img{
                width: 100%;
                height: 100%;
            }
        }
        width: 100%;
        height: 100%;
        position: relative;
        background-color: #f5f5f5;
        border-radius: 0.06rem 0.06rem 0 0;
        padding-top: 1px;
        background-image: url("../assets/logobg.png");
        background-repeat: no-repeat;
        background-size: 2.3rem;
        background-position: right top;
       .PersonContentWrap{
           .Translate{
               width: 93%;
               padding: 0.1rem;
               margin: 0.1rem auto 0;
               box-sizing: border-box !important;
               background-color: #fff;
               border-radius: 0.1rem;
               box-shadow: 0 0 10px #e2e2e2;
               p{
                   font-size: $TextSize;
                   color: #000;
                   line-height: 0.078rem;
               }
           }
           .LineCut{
               width: 93%;
               margin: 0.05rem auto 0.05rem;
               border-bottom: 2px solid #000;
               .Return{
                   cursor: pointer;
                   p{
                       font-size: $AdditionTextSize;
                       color: #fff;
                   }
                   img{
                       width: 0.05rem;
                       margin-left: 0.02rem;
                   }
               }
               .NewsTitle{
                   p{
                       font-size: $TitleSize;
                       color: #000;
                       padding-bottom: 0.045rem;
                       span{
                           opacity: 0.6;
                           font-weight: normal;
                       }
                   }
               }
           }
           .Info{
               margin-left: 0.12rem;
               margin-top: 0.07rem;
               .Infoitem{
                   height: 0.18rem;
                   img{
                       width: 0.075rem;
                   }
                   p{
                       font-size:$TextSize;
                       color: #000;
                       margin-left: 0.08rem;
                   }
               }
               .Itemcard{
                   width: 96%;
                   margin-top: 0.05rem;
                   div{
                       height: 0.1rem;
                       padding: 0 0.08rem;
                       box-sizing: border-box;
                       background-color: #999999;
                       color: #fff;
                       border-radius: 0.1rem;
                       font-size: $AdditionTextSize;
                       margin-right: 0.05rem;
                       float: left;
                       margin-bottom: 0.05rem;
                   }
                   .AddItem{
                       background-color: #00a7e6;
                       ::v-deep .el-button--text{
                           color: #fff;
                           cursor: pointer;
                       }
                   }
               }
           }
           .PersonHead{
               width: 1.5rem;
               height: 0.5rem;
               margin-left: 0.1rem;
               position: relative;
               img{
                   width:0.5rem;
                   height: 0.5rem;
                   object-fit: cover;
                   border-radius: 0.08rem;
               }
               .Name{
                   position: absolute;
                   bottom: 0.03rem;
                   left: 0.55rem;
                   p:last-child{
                       font-size: $SmallTitleSize;
                       font-weight: bold;
                       color: #666666;
                   }
                   p:first-child{
                       font-size: $SmallTitleSize;
                       margin-bottom: 0.02rem;
                       font-weight: bold;
                   }
               }
           }
           width: 96%;
           margin: 0 auto;
           height: calc(100% - 0.25rem);
           margin-top: 0.25rem;
           overflow-y: scroll;
           overflow-x: hidden;
           &::-webkit-scrollbar {
               width: 2px;
               height: 2px;
           }
           &::-webkit-scrollbar-track {
               width: 2px;
               background: #d2d2d2;

           }

           &::-webkit-scrollbar-thumb {
               width: 2px;
               background: #444444;
           }
       }
    }
</style>
